import React from 'react';

import '../../../assets/fontAwesome/css/all.css';
import '../../../common/styles/globalClasses.scss';
import './icon.scss';

interface IICon {
  name?: string;
  color?: string;
  className?: string;
  style?: {};
  disabled?: boolean;
  onClick?: (e: any) => void;
  id?: string;
}

const Icon: React.FC<IICon> = ({ name, className, onClick, disabled, id, style }) => {
  return (
    <span id={id} className={className + ` ${disabled ? 'disabled' : ''}`} onClick={!disabled ? onClick : undefined} style={style}>
      <i id={id} className={name} />
    </span>
  );
};
export default Icon;
